import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CredentialsInterceptor } from '@src/app/interceptors/credentials-interceptor';
import { HttpErrorInterceptor } from '@src/app/interceptors/error-interceptor';
import { AuthenticationService } from '@src/app/services/authentication.service';
import { PartnerService } from '@src/app/services/partner.service';
import { UrlService } from '@src/app/services/url.service';
import { VerificationService } from '@src/app/services/verification.service';
import { provideNgxMask } from 'ngx-mask';
import { routes } from './app.routes';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([CredentialsInterceptor, HttpErrorInterceptor])),
    provideNgxMask(),
    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        maxWidth: '100vw',
        maxHeight: '90vh',
        hasBackdrop: true,
        autoFocus: false,
      },
    },
    UrlService,
    PartnerService,
    AuthenticationService,
    VerificationService,
  ],
};
